<template>
    <div v-if="!isCreditOffer" class="column-container d-flex order-lg-4 order-1 mr-lg-auto">
        <OfferTerm v-if="!offer?.loan_amount?.max && offer?.term_display" />
        <OfferMonthlyRepayment v-else-if="offer?.monthly_repayment_display" />
    </div>

    <div class="column-container d-flex order-lg-2 order-2 mr-lg-auto">
        <OfferAmount />
    </div>

    <div v-if="offer?.total_repayment != 0" class="column-container d-flex order-lg-4 order-5 mr-lg-auto">
        <OfferTotalRepayment />
    </div>
</template>

<script>
export default {
    inject: ['offer'],
    computed: {},
}
</script>
